module.exports = __webpack_public_path__ + "img/01n.18fe2e16.gif";